import axios from "../../axios-atis";

import * as actionTypes from "./actionTypes";

export const fetchRequestsBegin = () => ({
  type: actionTypes.FETCH_REQUESTS_BEGIN,
});

export const fetchRequestsSuccess = (requests) => {
  return {
    type: actionTypes.FETCH_REQUESTS_SUCCESS,
    payload: { requests },
  };
};

export const fetchRequestsError = (error) => {
  return {
    type: actionTypes.FETCH_REQUESTS_FAILED,
    payload: { error },
  };
};
export const fetchRequests = (
  from,
  to,
  deleted,
  page,
  pageSize,
  filtred,
  sorted
) => {
  return (dispatch) => {
    dispatch(fetchRequestsBegin());
    let url = "/requests/" + from + "/" + to + "/" + deleted;
    axios
      .get(url)
      .then((response) => {
        dispatch(fetchRequestsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(fetchRequestsError(err));
      });
  };
};

export const fetchRequestBegin = () => ({
  type: actionTypes.FETCH_REQUEST_BEGIN,
});

export const fetchRequestSuccess = (request) => {
  return {
    type: actionTypes.FETCH_REQUEST_SUCCESS,
    payload: { request },
  };
};

export const fetchRequestError = (error) => {
  return {
    type: actionTypes.FETCH_REQUEST_FAILED,
    payload: { error },
  };
};
export const fetchRequest = (id) => {
  return (dispatch) => {
    dispatch(fetchRequestBegin());
    let url = "/requests/" + id;
    axios
      .get(url)
      .then((response) => {
        dispatch(fetchRequestSuccess(response.data));
      })
      .catch((err) => {
        dispatch(fetchRequestError(err));
      });
  };
};

export const addRequestBegin = () => {
  return {
    type: actionTypes.ADD_REQUEST_BEGIN,
  };
};

export const addRequestSuccess = (request) => {
  return {
    type: actionTypes.ADD_REQUEST_SUCCESS,
    payload: { request },
  };
};

export const addRequestError = (error) => {
  return {
    type: actionTypes.ADD_REQUEST_FAILED,
    payload: { error },
  };
};
export const redirect = link => {
  return { type: actionTypes.REDIRECT, payload: link };
};

/*export const addRequest = (newRequest) => {
  return (dispatch) => {
    dispatch(addRequestBegin());
    let url = "/requests";
    axios
      .post(url, newRequest)
      .then((response) => {
        dispatch(addRequestSuccess(response.data.result));
        dispatch(redirect("/requests"));
      })
      .catch((err) => {
        dispatch(addRequestError(err));
      });
  };
};*/

export const addRequestWithFiles = (fd) => {
  return (dispatch) => {
    dispatch(addRequestBegin());
    let url = "/requestsWithFiles";
    axios
      .post(url, fd)
      .then((response) => {
        dispatch(addRequestSuccess(response.data.result));
        dispatch(redirect("/requests"));
      })
      .catch((err) => {
        dispatch(addRequestError(err));
      });
  };
};

export const updtRequestBegin = () => {
  return {
    type: actionTypes.UPDATE_REQUEST_BEGIN,
  };
};

export const updtRequestSuccess = (request) => {
  return {
    type: actionTypes.UPDATE_REQUEST_SUCCESS,
    payload: { request },
  };
};

export const updtRequestError = (error) => {
  return {
    type: actionTypes.UPDATE_REQUEST_FAILED,
    payload: { error },
  };
};
/*export const updtRequest = (req) => {
  return (dispatch) => {
    dispatch(updtRequestBegin());
    let url = "/requests/" + req.id;
    axios
      .post(url, req)
      .then((response) => {
        if (!response || !response.data) {
          dispatch(updtRequestError(null));
        } else {
          dispatch(updtRequestSuccess(response.data.result));
        }
      })
      .catch((err) => {
        dispatch(updtRequestError(err));
      });
  };
};*/

export const updtRequest = (id, req) => {
  return (dispatch) => {
    dispatch(updtRequestBegin());
    let url = "/requests/" + id;
    axios
      .post(url, req)
      .then((response) => {
        if (!response || !response.data) {
          dispatch(updtRequestError(null));
        } else {
          dispatch(updtRequestSuccess(response.data.result));
        }
      })
      .catch((err) => {
        dispatch(updtRequestError(err));
      });
  };
};

export const addRequestMessageBegin = () => {
  return {
    type: actionTypes.ADD_REQUEST_MESSAGE_BEGIN,
  };
};

export const addRequestMessageSuccess = (request) => {
  return {
    type: actionTypes.ADD_REQUEST_MESSAGE_SUCCESS,
    payload: { request },
  };
};

export const addRequestMessageError = (error) => {
  return {
    type: actionTypes.ADD_REQUEST_MESSAGE_FAILED,
    payload: { error },
  };
};

export const addRequestMessage = (request, reqMsg) => {
  return (dispatch) => {
    dispatch(addRequestBegin());
    let url = "/requests/" + request.id + "/messages";
    axios
      .post(url, reqMsg)
      .then((response) => {
        if (!response || !response.data) {
          dispatch(addRequestMessageError(null));
        } else {
          var requestMessagesUpdated = request.requestMessages.reverse();
          requestMessagesUpdated.push(response.data.result);
          request.requestMessages = requestMessagesUpdated;
        }
        dispatch(addRequestMessageSuccess(request));
      })
      .catch((err) => {
        dispatch(addRequestMessageError(err));
      });
  };
};

export const removeRequestBegin = () => {
  return {
    type: actionTypes.REMOVE_REQUEST_BEGIN,
  };
};

export const removeRequestSuccess = (request) => {
  return {
    type: actionTypes.REMOVE_REQUEST_SUCCESS,
    payload: { request },
  };
};

export const removeRequestError = (error) => {
  return {
    type: actionTypes.REMOVE_REQUEST_FAILED,
    payload: { error },
  };
};
export const removeRequest = (req) => {
  return (dispatch) => {
    dispatch(removeRequestBegin());
    let url = "/requests/" + req.id;
    axios
      .delete(url)
      .then((response) => {
        if (
          null === response ||
          undefined === response ||
          undefined === response.data
        ) {
          dispatch(removeRequestError(null));
        } else {
          dispatch(removeRequestSuccess(response.data.result));
        }
      })
      .catch((err) => {
        dispatch(removeRequestError(err));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/request.js